import React from "react";
import { useIntl } from "react-intl";

// mui
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

// component
import CopyTool from "../copyTool/CopyTool";

const TopTool = () => {
  const intl = useIntl();
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography
          textAlign="left"
          variant="subtitle2"
          sx={{ fontWeight: 700, fontSize: "16px" }}
        >
          {intl.formatMessage({
            id: "sna.sidetool.digitalAITool.ocr.step2",
            defaultMessage: "2. OCR 結果",
          })}
        </Typography>
      </Grid>
      <Grid item>
        <CopyTool />
      </Grid>
    </Grid>
  );
};

export default TopTool;
